import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import logo from "../assets/logo-cotify-horizontal-negro.png";
import "./CreditsBlockedModal.css";

const CreditsBlockedModal = ({ visible, message, onClose }) => {
  return (
    <Dialog
      visible={visible}
      onHide={onClose}
      closable
      dismissableMask
      draggable={false}
      resizable={false}
      modal
      className="credits-blocked-dialog"
      showHeader={false}
      style={{ width: "92vw", maxWidth: 420 }}
    >
      <div className="credits-blocked-modal">
        <img src={logo} alt="Cotify" className="credits-blocked-modal__logo" />
        <p className="credits-blocked-modal__message">{message}</p>
        <Button
          label="Volver al inicio"
          className="credits-blocked-modal__btn"
          onClick={onClose}
        />
      </div>
    </Dialog>
  );
};

export default CreditsBlockedModal;
